// extracted by mini-css-extract-plugin
module.exports = {"list":"select_list__Zr69X","out_item":"select_out_item__Nkeh2","goBack":"select_goBack__j1hTC","header":"select_header__Q_bGA","tips":"select_tips__pJXcj"};